module.exports = __webpack_public_path__ + "static/img/CHARGE4.d13cb466.jpg";